<template>
  <div>
    <s-pageheader title="利润管理" />
    <ak-model-filter-card model="profit" @search="search" @reset="reset" />
    <ak-model-count-group class="m-b-20" :options="options"></ak-model-count-group>
    <ak-model-card model="profit" :perPage="30" :page.sync="page" :filters="filters" />
  </div>
</template>

<script>
import Bus from '@/assets/js/eventBus'
import PageHeader from '@/components/PageHeader/PageHeader'
export default {
  components: {
    's-pageheader': PageHeader,
  },
  data () {
    return {
      filters: {},
      page: 1,
      where: {},
    }
  },
  computed: {
    options () {
      let data = [
        {
          model: 'profit',
          icon: 'dollar',
          note: '实际利润',
          sum: 'realProfit',
          where: this.where,
          format: (val) => `${val || 0} 元`
        },
        {
          model: 'profit',
          icon: 'dollar',
          note: '利润R',
          sum: 'profitR',
          where: this.where,
          format: (val) => `${val || 0} 元`
        }
      ]
      return data
    }
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.where = filters
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.where = {}
      this.page = 1
      this.filters = {}
      Bus.$emit('reset', [])
    }
  }
}
</script>

<style>

</style>
